module.exports = __webpack_public_path__ + "img/building.7e78e943.svg";